import ObjectLogModel from './ObjectLogModel';
import { getEquipmentStatusLabel } from '../constants/options.js';
import { escapeHtml, titleCase } from '../util';

export default class CompanyEquipmentLogModel extends ObjectLogModel {
  init(data) {
    super.init(data);

    // do some cleanup so that the data is easier to use
    if (this.field == 'status') {
      this.old_value_display = getEquipmentStatusLabel(this.old_value);
      this.new_value_display = getEquipmentStatusLabel(this.new_value);
    } else if (this.field == 'location_id') {
      this.field = 'location';
    } else if (this.field == 'category_id') {
      this.field = 'category';
    } else if (this.field == 'manufacturer_id') {
      this.field = 'manufacturer';
    }
  }

  get log_display() {
    if (!this.field) return this.log_message;

    switch (this.field) {
      case 'self':
        return 'created the equipment.';
      case 'images':
        if (this.old_value_display) return `removed an Image: <strong>${escapeHtml(this.old_value_display)}</strong>`;
        if (this.new_value_display) return `added an Image: <strong>${escapeHtml(this.new_value_display)}</strong>`;
        break;
      case 'user_manual_files':
      case 'equipment_files':
      case 'existing_service_contract_files':
        if (this.old_value_display) return `removed an attachment: <strong>${escapeHtml(this.old_value_display)}</strong>`;
        if (this.new_value_display) return `added an attachment: <strong>${escapeHtml(this.new_value_display)}</strong>`;
        break;
      default:
        if (this.old_value_display && this.new_value_display) {
          return `updated the equipment ${titleCase(this.field)} from <strong>${escapeHtml(this.old_value_display)}</strong> to <strong>${escapeHtml(this.new_value_display)}</strong>`;
        }
        if (this.old_value_display) {
          return `removed the equipment ${titleCase(this.field)}: <strong>${escapeHtml(this.old_value_display)}</strong>`;
        }
        if (this.new_value_display) {
          return `set the equipment ${titleCase(this.field)}: <strong>${escapeHtml(this.new_value_display)}</strong>`;
        }
        return this.log_message;
    }
    return this.log_message;
  }
}
